import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import Badge from "@mui/material/Badge";
import {
  ArrowBack,
  Notifications,
  NotificationsNone,
} from "@mui/icons-material";
import AcoesButton from "./AcoesButton";
import "./notificacoes.css";
import { usePortalAuth } from "../../providers/keycloak-provider";
import { ListaMensagens } from "./ListaMensagens";
import VisualizacaoMensagem from "./VisualizacaoMensagem";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import {
  getNotifications,
  markAsAllRead,
  markAsRead,
  Notification,
} from "../../apis/notification-center-service";

class ClickMensagem {
  match(msg: Notification): boolean {
    return false;
  }
  execute(msg: Notification) {}
}

class RedirectClickMensagem extends ClickMensagem {
  match(msg: Notification) {
    return msg.content?.data?.redirect;
  }
  execute(msg: Notification) {
    window.open(msg.content?.data?.uri, "_self");
  }
}

const ACOES_CLICK = [new RedirectClickMensagem()];

export default function Notificacoes({ isBlue = false }: { isBlue: boolean }) {
  const { accessToken } = usePortalAuth();
  const [containerExpandido, setContainerExpandido] = useState<boolean>(false);
  const [mensagens, setMensagens] = useState<Notification[]>([]);
  const [mensagem, setMensagem] = useState<Notification | undefined>(undefined);
  const [countNaoLidas, setCountNaoLidas] = useState<number>(0);

  const refreshCountNaoLidas = () => {
    setCountNaoLidas(mensagens.filter((msg) => !msg.read).length);
  };

  useEffect(() => {
    const loadNotifications = async () => {
      const result = await getNotifications(accessToken);
      setMensagens(result || []);
    };

    if (accessToken) loadNotifications();
  }, [accessToken]);

  useEffect(() => {
    refreshCountNaoLidas();
  }, [mensagens]);

  const handleExpandirContainer = () => {
    setContainerExpandido(!containerExpandido);
  };

  const handleSelecionarMensagem = (msg: Notification) => {
    if (!msg.read) {
      msg.read = true;
      if (accessToken) {
        markAsRead(msg.id, accessToken);
        refreshCountNaoLidas();
      }
    }

    let deu_match = false;
    ACOES_CLICK.forEach((acao) => {
      if (acao.match(msg)) {
        deu_match = true;
        acao.execute(msg);
      }
    });

    if (!deu_match) {
      setMensagem(msg);
    }
  };

  const handleExibirListagem = () => {
    setMensagem(undefined);
  };

  const handleMarcarComoLidas = () => {
    if (accessToken) {
      const mensagensNaoLidas = mensagens
        ? mensagens.filter((msg) => !msg.read)
        : [];
      const ids = mensagensNaoLidas.map((msg) => msg.id);

      if (ids.length > 0) {
        markAsAllRead(ids, accessToken);
        mensagensNaoLidas.forEach((msg) => (msg.read = true));
        refreshCountNaoLidas();
      }
    }
  };

  let contentAcoes = <React.Fragment />;
  let content = <React.Fragment />;
  let btnVoltarVisibility = "hidden";

  if (mensagens.length > 0) {
    contentAcoes = (
      <AcoesButton handleMarcarComoLidas={handleMarcarComoLidas} />
    );
  } else {
    contentAcoes = <span className="span-acoes" />;
  }

  if (mensagem) {
    btnVoltarVisibility = "visible";
    content = <VisualizacaoMensagem mensagem={mensagem} />;
  } else {
    btnVoltarVisibility = "hidden";
    content = (
      <ListaMensagens
        mensagens={mensagens}
        handleClick={handleSelecionarMensagem}
      />
    );
  }

  const iconeNormal = (
    <NotificationsNone
      className={isBlue ? "icone-blue" : "icone"}
      color="action"
    />
  );
  const iconeExpandido = (
    <Notifications className={isBlue ? "icone-blue" : "icone"} color="action" />
  );

  return (
    <React.Fragment>
      <ClickAwayListener
        onClickAway={() => {
          setContainerExpandido(false);
        }}
      >
        <Box className={"box-notificacoes"}>
          <IconButton onClick={handleExpandirContainer}>
            <Badge badgeContent={countNaoLidas} color="warning">
              {containerExpandido ? iconeExpandido : iconeNormal}
            </Badge>
          </IconButton>
          <Box
            className={"container-notifications"}
            sx={{ display: containerExpandido ? "block" : "none" }}
          >
            <div className={"ajuste-borda"}></div>
            <Box className={"header"}>
              <IconButton
                aria-label="Voltar"
                size="small"
                onClick={handleExibirListagem}
                sx={{ visibility: btnVoltarVisibility }}
              >
                <ArrowBack />
              </IconButton>
              <span>Notificações</span>
              {contentAcoes}
            </Box>
            {content}
          </Box>
        </Box>
      </ClickAwayListener>
    </React.Fragment>
  );
}
